import React, { createContext, useContext, useState, useCallback, useEffect } from "react";
import { api } from "@/lib/api";

const AppContext = createContext(null);

export const AppProvider = ({ children }) => {
  const [roleKey, setRoleKey] = useState("six_lead");
  const [mode, setModeState] = useState(() => localStorage.getItem("six_mode") || "demo");
  const [simActive, setSimActive] = useState(false);
  const [simStep, setSimStep] = useState(0);
  const [simSteps, setSimSteps] = useState([]);
  const [overview, setOverview] = useState(null);

  const setMode = useCallback((m) => {
    setModeState(m);
    localStorage.setItem("six_mode", m);
  }, []);

  const refreshOverview = useCallback(async () => {
    try {
      const res = await api.get("/overview");
      setOverview(res.data);
    } catch (e) {
      // silent - unauthenticated sessions and topbar degrade gracefully
    }
  }, []);

  useEffect(() => {
    refreshOverview();
  }, [refreshOverview]);

  const startSimulation = useCallback(async () => {
    if (simSteps.length === 0) {
      try {
        const res = await api.get("/simulation");
        setSimSteps(res.data);
      } catch (e) { /* ignore */ }
    }
    setSimStep(0);
    setSimActive(true);
  }, [simSteps.length]);

  const stopSimulation = useCallback(() => setSimActive(false), []);

  return (
    <AppContext.Provider value={{
      roleKey, setRoleKey,
      mode, setMode,
      simActive, simStep, setSimStep, simSteps, startSimulation, stopSimulation,
      overview, refreshOverview,
    }}>
      {children}
    </AppContext.Provider>
  );
};

export const useApp = () => useContext(AppContext);
